import { GET_ALL_ORDER_NUMBER, GET_ALL_ORDER_NUMBER_ERROR, UPDATE_STATUS_FOR_DISPATCH, UPDATE_STATUS_FOR_DISPATCH_ERROR, UPDATE_DISPATCH_STATUS, UPDATE_DISPATCH_STATUS_ERROR } from '../type'
import axios from 'axios';
import env from '../../ENV';
// import swal from '@sweetalert/with-react';
let ROOT_URL = env.BACKEND_URL;


export const getAllOrderNumber = () => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}orderno/all`);
        dispatch({
            type: GET_ALL_ORDER_NUMBER,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_ORDER_NUMBER_ERROR,
            payload: console.log(e),
        })
    }

}


export const updateStatusForDispatch = (PurchaseOrderId, PurchaseOrderLineId, StatusId) => async dispatch => {

    // console.log("recieved in store ###### ", input)
    try {
        const res = await axios({
            method: 'patch',
            url: `${ROOT_URL}dispatch-status/${PurchaseOrderId}/${PurchaseOrderLineId}/${StatusId}`,
            // data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: UPDATE_STATUS_FOR_DISPATCH,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_STATUS_FOR_DISPATCH_ERROR,
            payload: console.log(e),
        })
    }

}

export const UpdateDispatchStatus = (PurchaseOrderId, PurchaseOrderLineId, proposedDate, incoTerms) => async dispatch => {

    // console.log("recieved in store ###### ", input)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/update-dispatch-status/${PurchaseOrderId}/${PurchaseOrderLineId}/${proposedDate}/${incoTerms}`,
            // data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: UPDATE_DISPATCH_STATUS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_DISPATCH_STATUS_ERROR,
            payload: console.log(e),
        })
    }

}